import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GENERIC_PAGINATED, getApiPath } from '../../api/ApiConst';
import { Logs } from '../../models/Log';

import DocumentList from '../genericcrud/DocumentList';

const RequestLogs = (props) => {
    const navigate = useNavigate();
    const [documentMeta, setDocumentMeta] = useState({});
    const [url, setUrl] = useState("");
    const [tableName, setTableName] = useState("");
    
    

   
    useEffect(() => {
        if (props.requestId) {
            
            setUrl(getApiPath( props.requestId, GENERIC_PAGINATED));
            setTableName(`log_${ props.requestId}`);
            Logs.basePath = `log-${ props.requestId}`
            setDocumentMeta({...Logs});
            //documentMeta.basePath = `log-${ props.requestId}`
        }
    }, [props.id, props.logTableName]);

    const getParametersTableView = useCallback(() => {
        return (
            <> {url && tableName && (
                <DocumentList documentMeta={documentMeta} isModel ={true} />
            )}
            </>
        );
    }, [documentMeta]);

    return (
        <>
            {getParametersTableView()}
        </>
    );
};

export default RequestLogs;
